import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CbClickDirective } from './click.directive';



@NgModule({
    declarations: [CbClickDirective],
    exports: [CbClickDirective],
    imports: [
        CommonModule
    ]
})
export class CbClickModule { }
